export default __webpack_public_path__ + "media/components/blocks/ProUpsell/feature_check-76b2ff8befc673cfc3f33c9ee2be0e94.png";